module.exports = __webpack_public_path__ + "static/media/headshot.1701f517.jpg";